import { MdCancel } from "react-icons/md";

export const TableSectionContent = ({ section, records }) => (
  <div className="adp-table-wrap">
    <table className="adp-files-event-table">
      <thead>
        <tr>
          {section.columns.map((column) => (
            <th key={column}>{column}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {records.map((record, index) => (
          <tr key={`${section.id}-row-${index}`}>
            {record.map((value, valueIndex) => (
              <td key={`${section.id}-${index}-${valueIndex}`}>
                {section.id === "events" && valueIndex === 3 ? (
                  <span className="adp-ellipsis-text adp-event-message" title={value}>{value}</span>
                ) : value}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const EventsSectionContent = TableSectionContent;

const EventsModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="adp-section-modal-overlay" >
      <div className="adp-section-modal" >
        <div className="adp-section-modal-header">
          <span>Events</span>
          <button className="adp-section-modal-close" type="button" onClick={onClose} aria-label="Close Events">
            <MdCancel size={25} />
          </button>
        </div>
        <div className="adp-section-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default EventsModal;
